@if ((product$ | async); as product) {
  @if (product?.arcInstructionsForUse?.length || product?.arcCleaningAdvices?.length) {
    @if (product?.arcInstructionsForUse) {
      <ng-container
        *ngTemplateOutlet="content;
       context: {
       title: 'productDetails.maintenanceInstructions', items: product.arcInstructionsForUse
       }"
      ></ng-container>
    }
    @if (product?.arcCleaningAdvices) {
      <ng-container
        *ngTemplateOutlet="content;
       context: {
       title: 'productDetails.cleaningAdvices', items: product.arcCleaningAdvices
       }"
      ></ng-container>
    }
  } @else {
    <div #hideParentComponent></div>
  }
  <ng-template #content let-title="title" let-items="items">
    @if (items?.length) {
      <div class="d-block  mb-4 pl-4 pr-4">
        <p class="mb-2">
          <b>{{ title | cxTranslate }}</b>
        </p>
        <ul>
          @for (item of items; track item) {
            <li>{{item.name}}</li>
          }
        </ul>
      </div>
    }
  </ng-template>
}
